
































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VHeaders, PaginationModel } from "@/models/pagedlistmodel";
import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { StandardFonts, LineCapStyle, PDFDocument, rgb, degrees } from "pdf-lib";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { attachmentService } from '@/shared';

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    VuePdfEmbed,
  },
})
export default class AnnotateInvoicePage extends Base {
  public isPdfRendering: boolean = false;
  public attachmentSize: string = '';
  public pagination = new PaginationModel("name");
  public pdfData = null;
  public context = null;
  public isCanvasType = "Pointer";
  public canvasInput = "";
  public showInput = false;
  public isShowFont = false;
  public isShowColorPicker = false;
  public attachmentUri: string = "";
  public attachmentName: string = "";
  public attachmentLoader: boolean = false;
  public base64: string = "";
  public loading: boolean = false;
  public pdfLoading: boolean = false;
  public buttons: any = [];
  public page = null;
  public pageCount = 1;
  public rotationAngle = 0;
  public coordinationArray: any = [];
  // public canvasUndoRedoArray: any = [];
  // public tempArray: any = [];
  public minFontSize: number = 2;
  public maxFontSize: number = 5;
  public fontStep: number = 1;
  public cStep = 0;
  public flags = {
    loading: false,
  };

  public cordinates = {
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
    inputFieldX: 0,
    inputFieldY: 0,
    fontSize: 2,
    fontColor: '#ff0000',
  };

  public canvasLoading: boolean = false;
  public canvasWidthHeight = {
    Width: "",
    Height: "",
  };

  public async mounted() {
    this.updateToolBar();

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.pdfLoading = true;
    this.attachmentUri = this.$route.params.uri;
    this.attachmentName = this.$route.params.attachmentName;
    var response = await attachmentService.getAttachmentByFileNameAsync(this.attachmentName);
    const sizeInBytes = response.fileSize;
    this.attachmentSize = (typeof sizeInBytes === 'number' && !isNaN(sizeInBytes))
      ? (sizeInBytes / (1024 * 1024)).toFixed(2)
      : '0.00';
    this.isPdfRendering = true;
    var attachmentBase64 = await this.getBase64FromBlobUrl(response.filePublicUri);
    const pdfDoc = await PDFDocument.load(attachmentBase64);

    // set paging on pdf
    const pages = pdfDoc.getPages();
    this.pageCount = pages.length;
    this.page = 1;
    const currentPage = pages[(this.page - 1)];
    // Get rotation angle of pdf for annotations
    this.rotationAngle = currentPage.getRotation().angle;
    this.pdfLoading = false;
  }

  public async getBase64FromBlobUrl(blobUrl: string): Promise<string> {
    const response = await fetch(blobUrl);
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    this.pdfData = uint8Array;
    // Convert Uint8Array to binary string
    let binary = '';
    for (let i = 0; i < uint8Array.length; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    // Encode binary string to base64
    return btoa(binary);
  }

  public onPdfLoaded() {
    // Once Pdf is loaded. set canvas dimensions to match those of rendered pdf size.
    // @ts-ignore
    this.context = this.$refs.canvas.getContext("2d");
    // @ts-ignore
    this.$refs.canvas.width = this.$refs.pdf.$el.offsetWidth;
    // @ts-ignore
    this.$refs.canvas.height = this.$refs.pdf.$el.children[0]
      .getElementsByTagName("canvas")[0]
      .style.height.replace("px", "");
    // @ts-ignore
    this.$refs.canvas.style.left = "26px";
    this.drawArrayOnCanvas();
  }
  public onPdfRendered() {
    this.isPdfRendering = false;
  }
  public mouseDown(e) {
    this.cordinates.startX = e.layerX;
    this.cordinates.startY = e.layerY;
  }

  public mouseMove(e) {
    this.cordinates.endX = e.layerX;
    this.cordinates.endY = e.layerY;

    if (this.cordinates.startX > 0 && this.cordinates.startY > 0
      && (this.isCanvasType == "Line" || this.isCanvasType == "Rectangle")
    ) { // @ts-ignore
      const ctx = this.$refs.canvas.getContext("2d");

      // Begin canvas drawing , set drawing colour and size
      ctx.beginPath();
      ctx.strokeStyle = this.cordinates.fontColor;
      ctx.lineWidth = this.cordinates.fontSize;

      if (this.isCanvasType == "Line") {

        this.drawArrowLineOnCanvas(ctx, this.cordinates.startX, this.cordinates.startY, this.cordinates.endX, this.cordinates.endY);

      } else {
        // Draw a rectangle using parameters, starting x y points , width and height.
        ctx.rect(
          this.cordinates.startX,
          this.cordinates.startY,
          this.cordinates.endX - this.cordinates.startX,
          this.cordinates.endY - this.cordinates.startY
        );
      }
      // @ts-ignore
      ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      ctx.stroke();
      ctx.closePath();
    }
  }

  public async mouseUp(e) {
    this.cordinates.endX = e.layerX;
    this.cordinates.endY = e.layerY;

    // push canvas drawings to an Array for making annotations all at once
    if (this.isCanvasType == "Line") {
      // remove elements saved for redo functionality
      this.removeTemporaryElements();
      this.coordinationArray.push({
        isCanvasType: "Line",
        startX: this.cordinates.startX,
        startY: this.cordinates.startY,
        endX: this.cordinates.endX,
        endY: this.cordinates.endY,
        isDraw: false,
        fontColor: this.cordinates.fontColor,
        fontSize: this.cordinates.fontSize,
        page: this.page
      });
      this.cStep++;
    }
    if (this.isCanvasType == "Text") {
      this.cordinates.inputFieldX = e.layerX;
      this.cordinates.inputFieldY = e.layerY;
      this.showInput = true;
    }
    if (this.isCanvasType == "Rectangle") {
      // remove elements saved for redo functionality
      this.removeTemporaryElements();
      this.coordinationArray.push({
        isCanvasType: "Rectangle",
        startX: this.cordinates.startX,
        startY: this.cordinates.startY,
        endX: this.cordinates.endX,
        endY: this.cordinates.endY,
        borderColor: rgb(1, 0, 0),
        borderWidth: 1.5,
        isDraw: false,
        fontColor: this.cordinates.fontColor,
        fontSize: this.cordinates.fontSize,
        page: this.page
      });
      this.cStep++;
    }
    this.cordinates.startX = 0;
    this.cordinates.startY = 0;
    this.cordinates.endX = 0;
    this.cordinates.endY = 0;

    this.drawArrayOnCanvas();
  }

  public changeType(type) {
    this.isCanvasType = type;
    if (type == "Text") {
      this.cordinates.fontSize = 12;
      this.minFontSize = 12;
      this.maxFontSize = 60;
      this.fontStep = 2;
      this.isShowFont = true;
    } else {
      this.cordinates.fontSize = 2;
      this.minFontSize = 2;
      this.maxFontSize = 3;
      this.fontStep = 1;
      this.isShowFont = false;
      this.showInput = false;
      this.isShowColorPicker = false;
    }
  }

  public async resetPdfAnnotation() {
    this.coordinationArray = [];
    this.cStep = 0;
    this.drawArrayOnPDF();
  }

  public async SaveDocument() {
    try {
      this.loading = true;
      await this.drawArrayOnPDF();
      const bytes = await this.bufferToBase64(this.pdfData);
      var response = await attachmentService.saveAnnotatedInvoice(bytes, this.attachmentName, this.attachmentUri);
      if (response.isUpdated) {
        this.showAlert(true, 'Invoice has been updated successfully.');
        this.$router.push({
          name: "app.expenses.annotateinvoice",
          params: {
            uri: response.updateFileUri.toString(),
            attachmentName: response.updatedFileName.toString()
          }
        });
      }
    } finally {
      this.loading = false;
    }
  }

  public async bufferToBase64(buffer) {
    // use a FileReader to generate a base64 data URI:
    const base64url = await new Promise((r) => {
      const reader = new FileReader();
      reader.onload = () => r(reader.result);
      reader.readAsDataURL(new Blob([buffer]));
    });
    // remove the `data:...;base64,` part from the start
    // @ts-ignore
    return base64url.slice(base64url.indexOf(",") + 1);
  }

  public async saveText(event) {
    if (this.isCanvasType == "Text") {
      if (this.canvasInput.trim() != '') {
        // remove elements saved for Undo redo functionality
        this.removeTemporaryElements();
        this.coordinationArray.push({
          isCanvasType: "Text",
          text: this.canvasInput,
          startX: this.cordinates.startX,
          startY: this.cordinates.startY,
          inputFieldX: this.cordinates.inputFieldX,
          inputFieldY: this.cordinates.inputFieldY,
          fontSize: this.cordinates.fontSize,
          fontColor: this.cordinates.fontColor,
          isDraw: false,
          page: this.page
        });
        this.cStep++;
      }
    }
    this.cordinates.inputFieldX = 0;
    this.cordinates.inputFieldY = 0;
    this.canvasInput = "";
    this.showInput = false;
    this.drawArrayOnCanvas();
  }

  public updateToolBar(): void {
    this.buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('apSearchReport.btnTitleBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('apSearchReport.btnBack'),
      click: 'back',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', this.buttons);
  }

  public callMethod(methodName): void {
    if (methodName == 'back') {
      this.$router.push({
        name: 'app.expenses.attachment',
      });
    }
    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public drawArrayOnCanvas() {
    // @ts-ignore
    const ctx = this.$refs.canvas.getContext("2d");

    let vm = this;

    for (var i = 1; i <= this.cStep; i++) {
      const element = this.coordinationArray[i - 1];
      if (element.page == this.page) {
        if (
          element.startX > 0 &&
          element.startY > 0 &&
          element.isCanvasType == "Line"
        ) {
          // set line stroke and line width
          ctx.beginPath();

          vm.drawArrowLineOnCanvas(ctx, element.startX, element.startY, element.endX, element.endY);
          ctx.strokeStyle = element.fontColor;
          ctx.lineWidth = element.fontSize;
          ctx.stroke();
          ctx.closePath();
        }

        if (
          element.startX > 0 &&
          element.startY > 0 &&
          element.isCanvasType == "Rectangle"
        ) {
          ctx.beginPath();
          ctx.strokeStyle = element.fontColor;
          ctx.lineWidth = element.fontSize;
          ctx.rect(
            element.startX,
            element.startY,
            element.endX - element.startX,
            element.endY - element.startY
          );
          ctx.stroke();
          ctx.closePath();
        }
        if (element.isCanvasType == "Text") {
          ctx.font = "normal " + (element.fontSize + 5) + "px Helvetica";
          ctx.fillStyle = element.fontColor;
          ctx.fillText(element.text, element.inputFieldX, element.inputFieldY);
        }
      }
    }
  }

  // Main Function for adding annotations on pdf
  public async drawArrayOnPDF() {
    // remove canvas drawings
    this.clearCanvas();

    // load pdf document into pdf-lib (library used for annotations)
    const pdfDoc = await PDFDocument.load(this.pdfData);
    // set font family for text annotations
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    //get all pages from document.
    const pages = pdfDoc.getPages();

    let vm = this;

    // Draw annotations for all pages 
    for (var pageNumber = 1; pageNumber <= this.pageCount; pageNumber++) {
      // set active page for drawing annotations
      const currentPage = pages[pageNumber - 1];
      //get pdf size of current pdf page
      const { width, height } = currentPage.getSize();

      // pdf and canvas have different dimensions. so we need to match them by ratio 
      // @ts-ignore 
      const widthRatioPdfToCanvas = width / this.$refs.canvas.width;    // @ts-ignore
      const heightRatioPdfToCanvas = height / this.$refs.canvas.height;

      for (var i = 1; i <= this.cStep; i++) {
        const element = this.coordinationArray[i - 1];
        if (element.page == pageNumber) {

          var elementColor = vm.hexToRgb(element.fontColor);

          // Note :- Some PDF files come with rotation angle so annotations on them move to wrong cordinates according to rotation angle of pdf document
          // So we need to calculate new location of cordinates and adjust the input given to pdf- lib
          if (element.isCanvasType == "Line") {

            // Adjust cordinates for starting and End point of Line
            // @ts-ignore
            var adjustedStartCords = vm.adjustRotationCordinates(element.startX, element.startY, vm.$refs.canvas.width, vm.$refs.canvas.height); // @ts-ignore
            var adjustedEndCords = vm.adjustRotationCordinates(element.endX, element.endY, vm.$refs.canvas.width, vm.$refs.canvas.height);

            // Annotate Line over Pdf
            vm.annotateLineOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, adjustedStartCords.x, adjustedStartCords.y, adjustedEndCords.x, adjustedEndCords.y, 2, elementColor);

            // For Converting a line into LineArrow, we attach an arrowhead at end point of Line.
            // This function calculates new cordinates for Arrowhead, 
            var arrowCordinates = vm.calculateArrowCoordinates(adjustedStartCords.x, adjustedStartCords.y, adjustedEndCords.x, adjustedEndCords.y);

            // Draw Arrowhead Lines on oth sides.
            vm.annotateLineOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, arrowCordinates.lowerX, arrowCordinates.lowerY, adjustedEndCords.x, adjustedEndCords.y, 3, elementColor);
            vm.annotateLineOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, arrowCordinates.upperX, arrowCordinates.upperY, adjustedEndCords.x, adjustedEndCords.y, 3, elementColor);
          }

          if (element.isCanvasType == "Rectangle") {
            // calculate starting point of rectangle.
            // @ts-ignore
            var adjustedStartCords = vm.adjustRotationCordinates(element.startX, element.startY, vm.$refs.canvas.width, vm.$refs.canvas.height);

            // annotate rectangle over pdf.
            vm.annotateRectangleOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, adjustedStartCords.x, adjustedStartCords.y, element, elementColor);
          }

          if (element.isCanvasType == "Text") {
            // calculate starting point of text annotation
            // @ts-ignore
            var adjustedStartCords = vm.adjustRotationCordinates(element.inputFieldX, element.inputFieldY, vm.$refs.canvas.width, vm.$refs.canvas.height);

            // annotate text over pdf 
            this.annotateTextOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, adjustedStartCords.x, adjustedStartCords.y, helveticaFont, element, elementColor);
          }
        }
      }
    }

    // Save all annotations on pdf
    const pdfBytes = await pdfDoc.save();

    // pass annotation pdf to vue pdf embed
    this.pdfData = new Uint8Array(pdfBytes);

    // clear all arrays used for managing canvas drawings.
    this.coordinationArray = [];
    this.cStep = 0;
    // this.canvasUndoRedoArray = [];
    // this.tempArray = [];
  }

  public canvasUndo() {
    // current step at which canvas drawing is
    if (this.cStep > 0) {
      this.cStep--;
      this.clearCanvas();
      this.drawArrayOnCanvas();
    }
  }

  public canvasRedo() {
    if (this.cStep < this.coordinationArray.length) {
      this.cStep++;
      this.clearCanvas();
      this.drawArrayOnCanvas();
    }
  }

  public calculateArrowCoordinates(x1, y1, x2, y2) {

    var dx = x2 - x1;
    var dy = y2 - y1;

    // Calculate angle of line annotated
    // using this angle, we add and substract 30 degrees to each side of this line and calculate arrow cordinates
    var angle = Math.atan2(dy, dx);
    // set arrow head length 1/10 of original line size
    var length = Math.sqrt(dx * dx + dy * dy) / 10;

    return {
      lowerX: x2 - length * Math.cos(angle + Math.PI / 7),
      lowerY: y2 - length * Math.sin(angle + Math.PI / 7),
      upperX: x2 - length * Math.cos(angle - Math.PI / 7),
      upperY: y2 - length * Math.sin(angle - Math.PI / 7)
    };
  }

  public adjustRotationCordinates(x, y, canvasWidth, canvasHeight) {
    // For 90 and 270 degrees, height becomes new width, width becomes height
    if (this.rotationAngle == 270) {
      var adJustedX = (canvasWidth / canvasHeight) * (canvasHeight - y);
      var adJustedY = (canvasHeight / canvasWidth) * (canvasWidth - x);
      return { x: adJustedX, y: adJustedY };
    }
    if (this.rotationAngle == 180)
      return { x: canvasWidth - x, y: y };

    // in case of rotation angle = 0
    return { x: x, y: canvasHeight - y };

    // In case of rotation angle = 90 
    // expected values would be, testing required.
    // var adJustedX = (canvasWidth / canvasHeight) * (y);
    // var adJustedY = (canvasHeight / canvasWidth) * (x);
  }

  public hexToRgb(hex) {
    return {
      r: parseInt(hex.slice(1, 3), 16),
      g: parseInt(hex.slice(3, 5), 16),
      b: parseInt(hex.slice(5, 7), 16)
    };
  }

  public switchCurrentPage(switchToNextPage: boolean) {
    this.clearCanvas();
    if (switchToNextPage) {
      this.page++;
      return;
    }
    this.page--;
  }

  public clearCanvas() {
    // @ts-ignore
    const ctx = this.$refs.canvas.getContext("2d"); // @ts-ignore
    ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
  }

  // common function used for annotating Lines
  public annotateLineOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, x1, y1, x2, y2, thickness, elementColor) {
    currentPage.drawLine({
      start: {
        x: widthRatioPdfToCanvas * x1,
        y: heightRatioPdfToCanvas * y1,
      },
      end: {
        x: widthRatioPdfToCanvas * x2,
        y: heightRatioPdfToCanvas * y2,
      },
      thickness: thickness,
      color: rgb(elementColor.r / 255, elementColor.g / 255, elementColor.b / 255),
      opacity: 1,
      lineCap: LineCapStyle.Round
    });
  }

  // common function used for annotating rectangle
  public annotateRectangleOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, x1, y1, element, elementColor) {
    var widthScaleRatio = 1;
    var heightScaleRatio = 1;

    // in case of 270 rotation, width and height get interchanged
    // calculate ratio for adjusting cordinates
    if (this.rotationAngle == 270) {                                    // @ts-ignore
      widthScaleRatio = this.$refs.canvas.height / this.$refs.canvas.width; // @ts-ignore
      heightScaleRatio = this.$refs.canvas.width / this.$refs.canvas.height;
    }
    currentPage.drawRectangle({
      x: widthRatioPdfToCanvas * x1,
      y: heightRatioPdfToCanvas * y1,
      width: widthRatioPdfToCanvas * (element.endX - element.startX) * widthScaleRatio,
      height: heightRatioPdfToCanvas * (element.startY - element.endY) * heightScaleRatio,
      borderColor: rgb(elementColor.r / 255, elementColor.g / 255, elementColor.b / 255),
      borderWidth: 1.5,
      rotate: degrees(-(360 - this.rotationAngle))
    });
  }

  // common function used for annotating text
  public annotateTextOnPdf(currentPage, widthRatioPdfToCanvas, heightRatioPdfToCanvas, x1, y1, font, element, elementColor) {
    currentPage.drawText(
      element.text, {
      x: widthRatioPdfToCanvas * x1,
      y: heightRatioPdfToCanvas * y1,
      font: font,
      size: element.fontSize + 3,
      color: rgb(elementColor.r / 255, elementColor.g / 255, elementColor.b / 255),
      lineHeight: element.fontSize + 5,
      opacity: 1,
      rotate: degrees(-(360 - this.rotationAngle)),
      maxWidth: 250
    },
    );
  }

  // Pop all elements saved for redo functionality
  public removeTemporaryElements() {
    if (this.coordinationArray.length > this.cStep) {
      // when All annotations have been removed
      if (this.cStep == 0) {
        this.coordinationArray = [];
        return;
      }
      // when all drawings are not removed
      var arrayLength = this.coordinationArray.length;
      for (var i = this.cStep; i < arrayLength; i++) {
        this.coordinationArray.pop();
      }
    }
  }

  public drawArrowLineOnCanvas(ctx, x1, y1, x2, y2) {
    // calculate Line distance and angle for creating arrowhead
    var dx = x2 - x1;
    var dy = y2 - y1;
    var angle = Math.atan2(dy, dx);
    var headlen = Math.sqrt(dx * dx + dy * dy) / 10;

    // Bring Drawing marker to starting cords and draw a line until end point of line
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);

    // bring drawing marker to end point and draw a line to side point for creating half arrowhead
    ctx.moveTo(x2, y2);
    ctx.lineTo(
      x2 - headlen * Math.cos(angle - Math.PI / 6),
      y2 - headlen * Math.sin(angle - Math.PI / 6)
    );

    // bring drawing marker to end point again and draw a line to opposite side point 
    ctx.moveTo(x2, y2);
    ctx.lineTo(
      x2 - headlen * Math.cos(angle + Math.PI / 6),
      y2 - headlen * Math.sin(angle + Math.PI / 6)
    );
  }
}
